module.exports = __webpack_public_path__ + "static/media/aa-shop.334e0205.png";